import React from 'react';
import { GroupDetail } from '../../../types/groupDetail';
import { EntityOverview, InfoColumn } from '../../shared';
import * as LucideIcons from 'lucide-react';

interface GroupOverviewProps {
  groupDetail: GroupDetail;
  infoColumns?: InfoColumn[];
  loadingMore?: boolean;
}

export const GroupOverview: React.FC<GroupOverviewProps> = ({ groupDetail, infoColumns, loadingMore = false }) => {
  const participantCount = groupDetail.members.length;
  const countDisplay = loadingMore ? `${participantCount}+` : `${participantCount}`;
  const subtitle = `${countDisplay} participant${participantCount !== 1 ? 's' : ''} / ${groupDetail.type}`;

  return (
    <EntityOverview
      avatar={
        <div
          style={{
            width: 200,
            height: 112.5, // 200 / (16/9) = 112.5
            borderRadius: '8px',
            overflow: 'hidden',
            background: groupDetail.avatarUrl ? 'transparent' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {groupDetail.avatarUrl ? (
            <img
              src={groupDetail.avatarUrl}
              alt={groupDetail.name}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <LucideIcons.Users 
              style={{ 
                color: '#fff', 
                width: '56px', 
                height: '56px',
                strokeWidth: 1.5 
              }} 
            />
          )}
        </div>
      }
      title={groupDetail.name}
      subtitle={subtitle}
      description={
        <p className="line-clamp-2">{groupDetail.description}</p>
      }
      infoColumns={infoColumns}
      className="mb-6"
    />
  );
};